import InputBase from "@mui/material/InputBase";
import { styled,alpha } from "@mui/material";

const InputBaseStyled = styled(InputBase)(({ theme }) => ({
  flex: 1,
  px: { xs: 1.25, sm: 1.75 },
  fontSize: "13px",
  color: "#444",
  minWidth: 0,
  "& input": {
    minWidth: 0,
  },
  "& input::placeholder": {
    color: alpha("#5f5f5f", 0.55),
    opacity: 1,
  },
}));

const RoundedTextBox = ({ value, onChange, placeholder, sx }) => {
  return (
    <InputBase value={value} onChange={onChange} placeholder={placeholder} />
  );
};

export default RoundedTextBox;
